function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import { SponsoredContent } from './SponsoredContent';
import { TagContent } from './TagContent';
import { AdvisersCTA } from './AdvisersCTA';
import { StorefrontCTA } from './StorefrontCTA';
import { ProductCTA } from './ProductCTA';
import { RawHTML } from './RawHTML';
import { ProductSnapshot } from './ProductSnapshot';
import { ProductSummaryCard } from './ProductSummaryCard';
import { ProductReviews } from './ProductReviews';
import { EmbeddedContent } from './EmbeddedContent';
var EMBED_CLASSES = ['sponsored-content', 'tag-content', 'advisers-cta', 'cta-storefront', 'product-cta', 'product-snapshot', 'product-summary', 'product-reviews'];
var widgetCatalog = [{
  class: 'sponsored-content',
  component: SponsoredContent,
  props: function props(_ref) {
    var attributes = _ref.attributes;
    return {
      id: attributes['data-id'],
      link: attributes['data-link'],
      logo: attributes['data-logo'],
      text: attributes['data-text'],
      cta: attributes['data-cta'],
      colorCTA: attributes['data-cta-color'],
      color: attributes['data-color']
    };
  },
  classTest: function classTest(node) {
    return node.outerHTML.includes('data-id') && node.outerHTML.includes('data-link');
  }
}, {
  class: 'tag-content',
  component: TagContent,
  props: function props(_ref2) {
    var attributes = _ref2.attributes;
    return {
      tag: attributes['data-tag'],
      title: attributes['data-title'],
      text: attributes['data-text'],
      textCTA: attributes['data-text-cta'] || 'Saber más',
      link: attributes['data-link'],
      linkRel: attributes['data-link-rel'],
      color: attributes['data-color'],
      colorCTA: attributes['data-color-cta'],
      colorBorder: attributes['data-color-border']
    };
  }
}, {
  class: 'advisers-cta',
  component: AdvisersCTA
}, {
  class: 'cta-storefront',
  component: StorefrontCTA,
  props: function props(_ref3) {
    var attributes = _ref3.attributes;
    return {
      tag: attributes['data-tag']
    };
  }
}, {
  class: 'product-cta',
  component: ProductCTA,
  props: function props(node, data) {
    return {
      product: data.product
    };
  }
}, {
  class: 'finect-pill',
  component: RawHTML,
  props: function props(_ref4) {
    var outerHTML = _ref4.outerHTML;
    return {
      html: outerHTML
    };
  }
}, {
  class: 'raw-html-embed',
  component: RawHTML,
  classTest: function classTest(node) {
    var _node$childNodes = node.childNodes,
      childNodes = _node$childNodes === void 0 ? [] : _node$childNodes;
    var _childNodes = _slicedToArray(childNodes, 1),
      firstNode = _childNodes[0];
    if (firstNode && childNodes.length === 1 && firstNode.rawTagName === 'iframe') {
      return false;
    }
    return !EMBED_CLASSES.find(function (className) {
      return node.outerHTML.includes(className);
    });
  },
  props: function props(_ref5) {
    var outerHTML = _ref5.outerHTML;
    return {
      html: outerHTML,
      ssr: false
    };
  }
}, {
  class: 'product-snapshot',
  component: ProductSnapshot,
  props: function props(_ref6) {
    var attributes = _ref6.attributes;
    return {
      id: attributes['data-id'],
      withLink: true,
      bottomMargin: true
    };
  }
}, {
  class: 'product-summary',
  component: ProductSummaryCard,
  props: function props(_ref7) {
    var attributes = _ref7.attributes;
    return {
      id: attributes['data-id'],
      subtype: attributes['data-subtype'],
      withLink: true
    };
  }
}, {
  class: 'product-reviews',
  component: ProductReviews,
  props: function props(_ref8) {
    var attributes = _ref8.attributes;
    return {
      finectApp: 'front-products',
      forceMoreButton: true,
      isin: attributes['data-isin'],
      product: attributes['data-product'],
      limit: attributes['data-limit'] || 2,
      order: attributes['data-order'] || '-score'
    };
  }
}, {
  class: null,
  component: EmbeddedContent,
  test: function test(node) {
    if (['iframe'].includes(node.rawTagName)) {
      var _node$attributes$src = node.attributes.src,
        src = _node$attributes$src === void 0 ? '' : _node$attributes$src;
      if (src.indexOf('https://www.youtube') === 0) {
        return true;
      }
    }
    return false;
  },
  props: function props(node) {
    return {
      node: node
    };
  }
}];
var classTestFn = function classTestFn(item, node) {
  return item.classTest ? item.classTest(node) : true;
};
export var getWidgetComponent = function getWidgetComponent(node) {
  var classList = node.classList;
  var byClass = widgetCatalog.find(function (item) {
    return classList.includes(item.class) && classTestFn(item, node);
  });
  if (byClass) {
    return byClass;
  }
  var byTest = widgetCatalog.filter(function (widget) {
    return widget.hasOwnProperty('test');
  }).find(function (widget) {
    return widget.test(node);
  });
  if (byTest) {
    return byTest;
  }
  return null;
};